// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablePaginationActions_root__3_qDj {\n  flex-shrink: 0;\n  margin-left: 20px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TablePaginationActions.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".root {\n  flex-shrink: 0;\n  margin-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "TablePaginationActions_root__3_qDj"
};
export default ___CSS_LOADER_EXPORT___;
